import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import distanceInWordsToNow from 'date-fns/formatDistanceToNow';
import format from 'date-fns/format';
import i18n from '../locale/i18n';
import md5 from "./md5";
import RestService from 'restService';
import Manager from './Manager';
import QualityMentoringForm from '../modules/quality-mentoring-form/models/QualityMentoringForm';
import frLocale from "date-fns/locale/fr-CA";

export function getLocale(): string {
  const components = window.location.pathname.split('/');
  return components[1] === 'fr' ? 'fr' : 'en';
}

export function toSlug(value: string) {
  value = value.toLocaleLowerCase();
  value = value.replace(/[^\w\s]/g, '');
  value = value.replace(/ /g, '-');
  return value;
}

export function formatTimestamp(value): string {
  const date = new Date(parseInt(value) * 1000);
  const today = new Date();
  const distance = differenceInCalendarDays(today, date);

  if (distance <= 31) {
    const dateOptions: any = {};
    if (i18n.global.locale == 'fr') {
      dateOptions.locale = frLocale;
    }
    const distanceString = distanceInWordsToNow(date, dateOptions);
    return i18n.global.t('created-ago', { date: distanceString });
  } else {
    return format(date, 'yyyy-MM-dd');
  }
}

export function nl2br(str, is_xhtml = false) {
  if (typeof str === 'undefined' || str === null) {
    return '';
  }
  var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

export async function getGravatarUrl(email: string): Promise<string> {
  const hash = md5(email);
  const gravatarUrl = `https://www.gravatar.com/avatar/${hash}`;
  const response = await fetch(`${gravatarUrl}?d=404`);
  if (response.status === 200) {
    return gravatarUrl;
  }
  return '';
}

export async function onDownloadReport(id) {
  document.body.classList.add('loading');

  const { submission } = Manager.getInstance();
  await RestService.put(`submission/${submission.id}`, {
    submission,
    percentComplete: QualityMentoringForm.getInstance().percentComplete,
  });

  const url = `${i18n.global.locale}/submission/${id}/report.pdf`;
  const filename = i18n.global.locale === 'fr' ? 'Mentorat-de-qualite-Rapport-auto-evaluation' : 'Quality-Mentoring-Assessment-Report';
  await RestService.download(url, filename).catch((e) => {
    document.body.classList.add('show-snackbar');
  });

  document.body.classList.remove('loading');
}
